import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import { twMerge } from "tailwind-merge";

import { useMenu } from "../../../store/global/useMenu";

export function LinkSubmenuItem({ hidden, to, className, onClick, ...rest }) {
  const { pathname } = useLocation();
  const acoesDoMenu = useMenu.getState().actions;

  // escolheu um destino: o submenu nao tem mais razao de ficar aberto por
  // cima da tela que acabou de abrir
  const aoClicar = (evento) => {
    acoesDoMenu.closeItems();
    if (onClick) onClick(evento);
  };

  return (
    <motion.span
      initial={{ maxHeight: 0, opacity: 0 }}
      animate={{ maxHeight: 32, opacity: 1 }}
      exit={{ maxHeight: 0, opacity: 0 }}
      transition={{ duration: 0.2, ease: "easeIn" }}
      className="flex w-full flex-1 h-fit min-w-48"
    >
      <Link
        {...rest}
        to={to}
        onClick={aoClicar}
        data-active={to === pathname}
        className={twMerge("py-1.5 pl-10 pr-3 text-zinc-700 transition duration-700 hover:font-bold hover:text-scale-400  w-full hover:duration-200 hover:pl-12 data-[active=true]:font-semibold data-[active=true]:pl-10 data-[active=true]:text-scale-400", className)}
      />
    </motion.span>
  );
}
